import { render, staticRenderFns } from "./AssessmentPreview.vue?vue&type=template&id=da1056f4&scoped=true"
import script from "./AssessmentPreview.vue?vue&type=script&lang=js"
export * from "./AssessmentPreview.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPreview.vue?vue&type=style&index=0&id=da1056f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1056f4",
  null
  
)

export default component.exports